import(/* webpackMode: "eager", webpackExports: ["GuidesMotionLayout"] */ "/vercel/path0/src/app/guides/_components/guides-motion-layout.tsx");
